import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CommonSearchCriteria from '../../../common/CommonSearchCriteria';
import CommonLoader from '../../../common/CommonLoader';
import TestLibsTable from './TestLibsTable';
import { GetTestLibs } from '../../../../services/TestLibService';
import { NotificationManager } from 'react-notifications';

const TestLibs = () => {
  const statusList = ['Active', 'InActive'];

  const [loading, setLoading] = useState(false);
  const [testLibsData, setTestLibsData] = useState([]);
  const [testLibsCount, setTestLibsCount] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState({
    searchText: '',
    orderStatus: 'Active',
    startDate: '',
    endDate: '',
    pageNumber: 0,
    pageSize: 10
  });

  useEffect(() => {    
    const today = new Date();
    const startDateValue = new Date(today);
    startDateValue.setDate(today.getDate() - 15);
    const endDateValue = new Date(today);
    endDateValue.setDate(today.getDate() + 15);

    const initialCriteria = {
      searchText: '',
      orderStatus: '',
      startDate: startDateValue.toISOString().split('T')[0],
      endDate: endDateValue.toISOString().split('T')[0],
      pageNumber: 0,
      pageSize: 10
    };

    setSearchCriteria(initialCriteria);
    if (isValidSearchCriteria(initialCriteria)) {
      getTestLibs(initialCriteria);
    }
  }, []);

  const isValidSearchCriteria = (criteria) => {    
    // Add your criteria validation logic here
    return  criteria.orderStatus !== '' || criteria.startDate !== '' || criteria.endDate !== '';
  };
  const getTestLibs = async (searchCriteria) => {    
	if(searchCriteria.startDate==="" || searchCriteria.endDate===""){
		return
	}
    try {
      setLoading(true);
      const response = await GetTestLibs(
        searchCriteria.startDate,
        searchCriteria.endDate,
        searchCriteria.orderStatus,
        searchCriteria.searchText,
        searchCriteria.pageNumber,
        searchCriteria.pageSize
      );
      setTestLibsData(response.results);
      setTestLibsCount(response.count);
    } catch (err) {
      NotificationManager.error('Error getting test libraries. ' + err, 'Error');
    } finally {
      setLoading(false);
    }
  };

  const handleSearchCriteria = async (changedSearchCriteria) => {    
    const updatedSearchCriteria = {
      ...searchCriteria,
      startDate: changedSearchCriteria.startDate,
      endDate: changedSearchCriteria.endDate,
      orderStatus: changedSearchCriteria.orderStatus,
      searchText: changedSearchCriteria.searchText,
      pageNumber: 0,
    };
    setSearchCriteria(updatedSearchCriteria);
    getTestLibs(updatedSearchCriteria);
  };

  const onChangePageSettings = async (pageNumber, pageSize) => {    
    const updatedSearchCriteria = {
      ...searchCriteria,
      pageNumber: pageNumber,
      pageSize: pageSize
    };
    setSearchCriteria(updatedSearchCriteria);
    getTestLibs(updatedSearchCriteria);
  };

  return (
    <div className="vlp-component-container">      
    <span className="title">Test Library Management </span>
    <hr />
      <div className="columns">
        <div className="column">
          <CommonSearchCriteria
            orderStatusOptions={statusList}
            onSearch={handleSearchCriteria}
            extraActions={
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<AddIcon />}
                style={{ height: "40px", whiteSpace: "nowrap" }}
                onClick={() => window.open("/vlp/maintenance-test-library-management/add", "_blank")}
              >
                New
              </Button>
            }
          />
        </div>
      </div>
      <TestLibsTable testLibsData={testLibsData} count={testLibsCount} onChange={onChangePageSettings} />
      <CommonLoader loading={loading} />
    </div>
  );
};

export default TestLibs;